import './index.css';
// import 'antd/dist/antd.css';
import 'antd/dist/antd.variable.css';
import "react-custom-scroll/dist/customScroll.css";
import 'antd-country-phone-input/dist/index.css';
import React                     from 'react';
import ReactDOM                  from 'react-dom';
import {IconContext}                  from "react-icons";
import {BrowserRouter as Router}      from "react-router-dom";
import {ConfigProvider, notification} from "antd";
import {ConfigProvider as PhoneProvider}               from "antd-country-phone-input";
import en_countries from 'world_countries_lists/data/countries/en/world.json';
import bg_countries from 'world_countries_lists/data/countries/bg/world.json';
import antLocale_BG                   from 'antd/lib/locale/bg_BG';
import antLocale_EN                   from 'antd/lib/locale/en_US';
import * as Sentry                    from "@sentry/browser";
import {Integrations}                 from "@sentry/tracing";
import AppAdmin                       from "./AppAdmin";
import AppGroupAdmin                  from "./AppGroupAdmin";
import AppUser                        from "./AppUser";
import AppNoLogin                     from "./AppNoLogin";
import api, {init, on}                from "./js/api";
import utils                          from "./js/utils.js";
import locale                         from "./localization/locale.js";
import lookups                        from "@tools/lookups.json";
import en_US                          from "./locales/en.json";
import bg_BG                          from "./locales/bg.json";
import DriverLogin                    from "./components/DriverLogin.js";
import SellerLogin                    from "./components/SellerLogin.js";
import LoginForm                      from "./components/LoginForm.js";
import {GlobalContextProvider}        from "./components/contexts/GlobalContext.js";
import themeConfig                    from './_resources/themeConfig.json';
import i18n                           from '@tools/i18n'
import pagesNoLogin                   from "@tools/page_list_no_login";
import EventEmitterRC from "@tools/eventEmitterContext/EventEmitterRC";
const allowLanguages = ["en", "bg"]

const iconClassName = "icons";

const initErrorHandling = () => {
    const environment = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV
    if (environment === "development")
        return;

    Sentry.init({
        serverName: `Fuel2Go Desktop ${process.env.REACT_APP_MOBILE_APP_S3_PATH}`,
        dsn: process.env.REACT_APP_SENTRY_DSN,
        integrations: [
            new Integrations.BrowserTracing(),
            new Sentry.Integrations.Breadcrumbs({console: false})
        ],
        tracesSampleRate: 1.0,
        environment
    });
}

let setLocale = (lang) => {
    switch(lang){
        case "en":
            locale.setMain(en_US);
            break;
        case "bg":
            locale.setMain(bg_BG);
            break;
        default:
            locale.setMain(en_US);
    }
};

let getAntLocale = (lang) => {
    switch(lang){
        case "en":
            return antLocale_EN;
        case "bg":
            return antLocale_BG;
        default:
            return antLocale_EN;
    }
};

let reset_user = async ({lang}) => {
    utils.setCookie("token", "");
    await init({token: ""});
    await render({lang})
};

let onLogout = async () => {
    let lang = utils.getCookie("lang");
    await api("logout", {});
    await reset_user({lang});
    window.location.href = "/"
};

let onLogin = async ({token, user}) => {
    let lang = utils.getCookie("lang");
    await init({token: token});
    await render({token, user, lang})
};

let render = async({token, user, lang}) => {
    let content = null;
    const pageName = window.location.pathname.split("/")[1];

    if (pagesNoLogin.some(page => page.id === pageName)) {
        const antLocale = getAntLocale(lang);
        content = renderNoLoginPages({locale: antLocale})
    }

    else if (!token || !user?.role) {
        content =  <LoginForm cbLogin={onLogin}/>
    }
    else {
        let rootFacility = {}
        if(user?.role?._id !== "superAdmin") {
            rootFacility = await api("get_root_facility", {});
        }

        const appsVersion = await api("get_apps_version", {});
        const environment = {
            s3_bucket : process.env.REACT_APP_S3_BUCKET,
            aws_region : process.env.REACT_APP_S3_REGION
        }

        const antLocale = getAntLocale(lang)

        if (user.role.loginType === lookups.obj.securityGroup.loginType.activationCode) {
            if (user.role._id === "driver")
                content = renderDriver({token, user, lang, fuelMetrix: rootFacility, environment, appsVersion, locale: antLocale})
        }
        else if (user.role.allTenants === lookups.obj.securityGroup.allTenants.allow) {
            content = renderAdminApp({token, user, lang, fuelMetrix: rootFacility, environment, appsVersion, locale: antLocale})
        }
        else if (user.role.facilityCategory.includes(lookups.obj.securityGroup.facilityCategory.administrator)) {
            content = renderGroupAdminApp({token, user, lang, fuelMetrix: rootFacility, environment, appsVersion, locale: antLocale})
        }
        else {
            let userCompanies = await api("get_user_company", {})
            if (userCompanies.count) {
                userCompanies = userCompanies.data
                content = renderUserApp({token, user, lang, fuelMetrix: rootFacility, environment, appsVersion, locale: antLocale, userCompanies})
            }
            else
                content =  <LoginForm cbLogin={onLogin}/>
        }
    }
    ReactDOM.render(content, document.getElementById('root'));
};

let renderDriver = (data) =>
    <GlobalContextProvider value={data}>
        <ConfigProvider locale={data.locale}>
            <IconContext.Provider value={{ className: iconClassName }}>
                <DriverLogin cbLogout={onLogout} {...data}/>
            </IconContext.Provider>
        </ConfigProvider>
    </GlobalContextProvider>;

let renderSeller = (data) =>
    <GlobalContextProvider value={data}>
        <ConfigProvider locale={data.locale}>
            <IconContext.Provider value={{ className: iconClassName }}>
                <SellerLogin cbLogout={onLogout} {...data}/>
            </IconContext.Provider>
        </ConfigProvider>
    </GlobalContextProvider>;

let renderUserApp = (data) =>
    <EventEmitterRC>
        <GlobalContextProvider value={data}>
            <ConfigProvider locale={data.locale}>
                <IconContext.Provider value={{ className: iconClassName }}>
                    <Router>
                        <AppUser cbLogout={onLogout} {...data}/>
                    </Router>
                </IconContext.Provider>
            </ConfigProvider>
        </GlobalContextProvider>
    </EventEmitterRC>;

let renderAdminApp = (data) =>
    <EventEmitterRC>
        <GlobalContextProvider value={data}>
            <ConfigProvider locale={data.locale}>
                <PhoneProvider locale={data.locale === "en" ? en_countries : bg_countries}>
                    <IconContext.Provider value={{ className: iconClassName }}>
                        <Router>
                            <AppAdmin cbLogout={onLogout} {...data}/>
                        </Router>
                    </IconContext.Provider>
                </PhoneProvider>
            </ConfigProvider>
        </GlobalContextProvider>
    </EventEmitterRC>;

let renderGroupAdminApp = (data) =>
    <EventEmitterRC>
        <GlobalContextProvider value={data}>
            <ConfigProvider locale={data.locale}>
                <PhoneProvider locale={data.locale === "en" ? en_countries : bg_countries}>
                    <IconContext.Provider value={{ className: iconClassName }}>
                        <Router>
                            <AppGroupAdmin cbLogout={onLogout} {...data}/>
                        </Router>
                    </IconContext.Provider>
                </PhoneProvider>
            </ConfigProvider>
        </GlobalContextProvider>
    </EventEmitterRC>;

let renderNoLoginPages = (data) =>
    <GlobalContextProvider value={data}>
        <ConfigProvider locale={data.locale}>
            <IconContext.Provider value={{ className: iconClassName }}>
                <Router>
                    <AppNoLogin />
                </Router>
            </IconContext.Provider>
        </ConfigProvider>
    </GlobalContextProvider>;


window.onload = async () => {
    ConfigProvider.config(themeConfig);
    initErrorHandling();

    let token = utils.getCookie("token");
    let lang = utils.getCookie("lang");
    if(!allowLanguages.includes(lang)) {
        lang = "en"
        utils.setCookie("lang", lang)
    }

    await i18n(lang);
    setLocale(lang);
    await init({token});

    on("error", async (e) => {

        if(e.error === -7) {
            await reset_user({lang})
        }
        else {
            notification.error({
                message: locale.get("common.server_error"),
                description: e.message,
            });
        }
    });

    if (token && token !== "undefined") {
        const user = await api("get_logged_user_props", {}, {return_error: true});
        if (user.statusCode){
            return await reset_user({lang})
        }
        await render({token, user, lang})
    }
    else {
        await render({lang})
    }
};
